import { get, ref } from "firebase/database";
import { useEffect, useState } from "react";

import { database } from "../../firebase/firebase";
import { normalizePlace } from "../../lib/pricing";

/**
 * Nomes dos locais ativos da tabela de preços, para sugerir origem/destino no
 * formulário de reserva. Leitura única (sem listener) para não pesar o admin.
 */
export function usePlaceNames(): string[] {
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    let cancelled = false;
    get(ref(database, "pricing/places"))
      .then((snapshot) => {
        if (cancelled || !snapshot.exists()) return;
        const list = Object.values(snapshot.val() as Record<string, unknown>)
          .map(normalizePlace)
          .filter((place) => place && place.active)
          .map((place) => place!.name)
          .sort((a, b) => a.localeCompare(b, "pt-BR"));
        setNames(list);
      })
      .catch(() => {
        // sem tabela de preços ainda: mantém apenas as sugestões do catálogo
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return names;
}
